import { AppLocaleOnView } from 'shared/types/locale';
import { DateTime } from 'luxon';
import { ProjectModel } from 'shared/domain/project/types/model';
import { toViewDate } from 'shared/utils/date/toViewDate';
import { anyToAppLocaleOnView } from 'shared/utils/locale/anyLocaleCodeToAppLocaleOnView';

export interface ProjectOnSingleView {
  _id: string;
  organizationId: string;
  name: string;
  timezone: string;
  budget: number;
  currency: string;
  projectStartDate: DateTime | null | undefined;
  projectEndDate: DateTime | null | undefined;
  locale: AppLocaleOnView;
}

/** The project as its details view shows it. */
export function modelToSingleView(
  model: ProjectModel
): ProjectOnSingleView {
  const {
    _id,
    organizationId,
    name,
    timezone,
    budget,
    currency,
    projectStartDate,
    projectEndDate,
    localeCode,
  } = model;

  return {
    _id,
    organizationId,
    name,
    timezone,
    budget: budget || 0,
    currency,
    projectStartDate: toViewDate(timezone, projectStartDate),
    projectEndDate: toViewDate(timezone, projectEndDate),
    locale: anyToAppLocaleOnView(localeCode),
  };
}
